<template>
  <v-select
    v-bind="attrs"
    :multiple="multiple"
    density="compact"
    variant="outlined"
    :class="{
      'success-field': success,
      'error-field': errorMessages.length
    }"
    :base-color="success ? 'success' : 'basic'"
    :color="success ? 'success' : 'primary'"
    :error-messages="errorMessages"
  >
    <template v-if="$slots.item" #item="slotProps">
      <slot name="item" v-bind="slotProps" />
    </template>
    <template v-else #item="slotProps">
      <template v-if="slotProps?.item?.raw?.header">
        <v-divider />
        <v-list-item
          :title="slotProps?.item?.raw?.header"
          class="list-item-header"
        />
      </template>
      <v-list-item
        v-else
        v-bind="slotProps.props"
        class="list-item"
        :data-testid="slotProps.props.title"
      >
        <template v-if="multiple" #prepend="{ isSelected }">
          <v-list-item-action start>
            <v-checkbox-btn :model-value="isSelected"></v-checkbox-btn>
          </v-list-item-action>
        </template>
      </v-list-item>
    </template>
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
    <template v-if="$slots.message" #message="{ message }">
      <slot name="message" :message="message" />
    </template>
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
    <template
      v-if="$slots['append-inner'] || activeSaveController"
      #append-inner
    >
      <slot name="append-inner" />
      <active-save-indicator
        v-if="activeSaveController"
        :controller="activeSaveController"
      />
    </template>
  </v-select>
</template>

<script setup>
import ActiveSaveIndicator from "@/components/shared/active-save/ActiveSaveIndicator.vue";
import { useAttrs } from "vue";

defineProps({
  multiple: Boolean,
  success: Boolean,
  errorMessages: { type: Array, default: () => [] },
  activeSaveController: {
    type: Object,
    required: false,
    default: null
  }
});

const attrs = useAttrs();
</script>

<style lang="scss">
.list-item-header {
  .v-list-item__content {
    font-weight: 500 !important;
    font-size: 14px;
    color: #696969;
  }
}
.list-item {
  .v-list-item-title {
    padding-left: 12px;
  }
}
</style>
